import '../styles/Title.css';
import '../styles/MediaQueries.css';
import Buttons from '../../../components/Buttons';
import { useNavigate } from 'react-router-dom';


function Title() {
    const navigate = useNavigate();

    function slideDown() {
        window.scrollTo({
            top: window.innerHeight - 200,
            behavior: "smooth"
        });
    }

    function openBooking() {
        navigate('booking');
    }

    return (
        <div className="main-section">
            <svg viewBox="0 0 220 220" fill="none" id="icon">
                <path
                    d="M86.594 44H144.835C149.142 44 152.046 48.4043 150.349 52.3635L98.9209 172.364C97.9754 174.57 95.8062 176 93.406 176H35.1654C30.8579 176 27.9537 171.596 29.6505 167.636L81.0791 47.6365C82.0246 45.4304 84.1938 44 86.594 44Z"
                    fill="rgb(214, 204, 194)" stroke="rgb(214, 204, 194)" strokeWidth="8">
                </path>
                <path
                    d="M106.594 44H164.835C169.142 44 172.046 48.4043 170.349 52.3635L118.921 172.364C117.975 174.57 115.806 176 113.406 176H55.1654C50.8579 176 47.9537 171.596 49.6505 167.636L101.079 47.6365C102.025 45.4304 104.194 44 106.594 44Z"
                    stroke="rgb(213, 189, 175)" strokeWidth="8">
                </path>
            </svg>
            <div className="title-section">
                <h1>Dive Into History at <br /> Edakkal</h1>
            </div>
            <Buttons firstText="Explore Now" secondText="Book Tickets" firstClicked={slideDown} secondClicked={openBooking} />
        </div>

    );
}

export default Title;